import { CommonComponentProps } from 'approot/activity-builder/activity-builder.constants';
import { ComponentGuidedResearch } from '../component.constants';

export type ViewProps = Omit<ComponentGuidedResearch, '__typename'>;
export type EditProps = ViewProps & CommonComponentProps;
export type SettingsProps = Omit<ComponentGuidedResearch, '__typename'> &
  CommonComponentProps;

export const GUIDED_RESEARCH_TITLE = 'Guided Research';
